import { createContext, useContext, type PropsWithChildren } from 'react';

import { type SessionPageHost } from './host';

const SessionPageHostContext = createContext<SessionPageHost | null>(null);

/** Mounted by the session pages and the Work session members. */
export const SessionPageHostProvider = ({
  host,
  children,
}: PropsWithChildren<{ host: SessionPageHost }>) => (
  <SessionPageHostContext.Provider value={host}>
    {children}
  </SessionPageHostContext.Provider>
);

/** Throws when a session-page module renders outside the provider. */
export const useSessionPageHost = (): SessionPageHost => {
  const host = useContext(SessionPageHostContext);
  if (!host) {
    throw new Error('SessionPageHost read outside SessionPageHostProvider');
  }
  return host;
};
